import {
  Box,
  Button,
  Checkbox,
  ListItemText,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import React, { useCallback, useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import RoleService from "services/RoleService";
import { AuthData } from "auth/AuthWarpper";
import { useLocation, useNavigate } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
import AccessTable from "../Common/AccessTable";
import { useTranslation } from "react-i18next";
import Delegation from "assets/delegation.svg";
import { convertUtcToLocalDate, formatDateToLocal } from "utils/utils";
import CustomPagination from "components/pages/Import/Common/CustomPagination";

let originalData = []
const SelfDelegationList = () => {
  const location = useLocation();
  const { user } = AuthData();
  const navigate = useNavigate();
  const { rowData } = location.state || {};
  const { setOpenAlert, setSeverity, setMessage, handleClose } =
    useContext(SnackbarContext);
  const [userName, setUserName] = useState(rowData?.userName || "");
  const { t, i18n } = useTranslation()
  const [formData, setFormData] = useState({
    profile: rowData?.batOneId || "",
    fieldTechnician: "",
    role: rowData?.profileId || "",
    serviceNumber: rowData?.serviceNumber || "",
    remarks: rowData?.remarks || "",
    countryCode: rowData?.countryCode || "",
    fromBatId: "",
    toBatId: "",
  });

  const [loading, setLoading] = React.useState(false);
  const [data, setData] = useState([]);
  const columns = [
    { label: t("otherDelegation.delegation"), field: "delegate", align: "left" },
    { label: t("otherDelegation.batOneId"), field: "batOneId", align: "left" },
    { label: t("otherDelegation.start"), field: "start", align: "left" },
    { label: t("otherDelegation.end"), field: "end", align: "left" },
    { label: t("otherDelegation.status"), field: "status", align: "left" },
    { label: t("Action"), field: "action", align: "left" },
  ];
  const [status, setStatus] = useState(['Active', 'Inactive']); // Example initial state (can be empty or predefined)
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(5);

  const paginate = (pageNumber, itemsPerPage) => {
    fetchData(pageNumber - 1, itemsPerPage);
  };


  const fetchData = async (pNumber, size) => {
    setLoading(true);
    const query = {
      batOneId: user?.batOneId,
      pageNumber: pNumber,
      size: size,
      status: status ? status?.length > 1 ? null : status == "Active" ? "true" : "false" : null,
    };
    try {
      const response = await RoleService.isSelfDelegation(query);
      const responseData = response?.data?.response?.delegation;
      setTotalItems(response?.data?.response?.totalItems);
      if (Array.isArray(responseData)) {
        const rows = responseData.map((item) => ({
          delegationId: item.delegationId,
          fromBATID: item.fromBATID,
          delegate: item.toName,
          batOneId: item.toBATID,
          start: formatDateToLocal(item.startDate),
          end: formatDateToLocal(item.endDate),
          startLocal: convertUtcToLocalDate(item.startDate),
          endLocal: convertUtcToLocalDate(item.endDate),
          fromName: item.fromName,
          fromEmail: item.fromEmail,
          toName: item.toName,
          toEmail: item.toEmail,
          toBATID: item.toBATID,
          status: item.isActive === true ? "Active" : "In Active",
        }));
        setData(rows);
        originalData = rows
        setCurrentPage(pNumber);
        setItemsPerPage(size);
      } else {
        console.warn("Unexpected response format:", responseData);
        setData([]); // Clear data if response format is unexpected
        originalData = []
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong.";
      setSeverity("error");
      setMessage(errorMessage);
      setOpenAlert(true);
      setData([]); // Clear data on error
      originalData = []
    } finally {
      setLoading(false); // Ensure loading state is cleared regardless of success or failure
    }
  };

  useEffect(() => {
    if (user?.batOneId) {
      fetchData(currentPage, itemsPerPage);
    }
  }, [user?.batOneId, currentPage, itemsPerPage, status]); // Added dependency to ensure re-fetching when user ID changes
  const handleStatusChange = (event) => {
    const { value } = event.target;
    setStatus(value);  // Updates the array of selected values
    setCurrentPage(0)
  };

  useEffect(() => {
    const filteredArray = originalData.filter((item) => status.includes(item.status));
    setData(filteredArray)
  }, [status])

  return (
    <LayoutAccessManagement>
      <Box sx={{ paddingBottom: "150px" }}>
        <Box
          sx={{
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Box>
              <FormControl sx={{ width: "403px" }} fullWidth variant="outlined">
                <InputLabel>{t("status")}</InputLabel>
                <Select
                  multiple  // Enable multiple selection
                  value={status}  // Array holding the selected values (e.g., ['active', 'inactive'])
                  onChange={handleStatusChange}
                  label={t("status")}
                  renderValue={(selected) => (
                    <div>
                    </div>
                  )}
                >
                  <MenuItem value="Active">
                    <Checkbox checked={status.indexOf('Active') > -1} />
                    <ListItemText primary="Active" />
                  </MenuItem>
                  <MenuItem value="Inactive">
                    <Checkbox checked={status.indexOf('Inactive') > -1} />
                    <ListItemText primary="Inactive" />
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                sx={{
                  pt: '6px',
                  pr: '15px',
                  pb: '6px',
                  pl: '15px',
                  background: '#ffffff',
                  boxShadow: "0px 1.478px 2.957px 0px rgba(0, 0, 0, 0.16)",
                  color: "#0A3575",
                  fontWeight: 500,
                  borderRadius: "11px",
                  border: '0.739px solid #FFF',
                  color: '#0A3575',
                  fontSize: '20.696px',
                  fontFamily: 'Montserrat',
                  textTransform: 'capitalize',
                  fontWeight: '500',
                }}
                startIcon={<img src={Delegation} alt="delegation" />}
                // onClick={() => navigate("/delegationNew")}
                onClick={() => navigate('/selfDelegation', { state: { fromUrl: 'selfDelegationList' } })}
                disabled={data && data[0]?.status == "Active"}
              >
                {t("otherDelegation.addDelegation")}
              </Button>
            </Box>
          </Box>

          <AccessTable
            columns={columns}
            rows={data}
            url={"/editDelegation"}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 5,
              mb: 2,
            }}
          >
          </Box>
        </Box>
      </Box>
      {data.length !== 0 ?
        <Box>
          <div style={{ position: "absolute", width: "96%", bottom: "70px" }}>
            <CustomPagination
              itemsPerPage={itemsPerPage}
              setItemsPerPage={(v) => setItemsPerPage(v)}
              totalItems={totalItems}
              paginate={paginate}
              currentPage={currentPage}
            />
          </div>
        </Box> : ""}
    </LayoutAccessManagement>
  );
};

export default SelfDelegationList;
